import _typeof from '@babel/runtime-corejs3/helpers/typeof';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import { invariant } from '../../../@react-dnd/invariant/dist/esm/d3abb5e672e7778a38d58eaa2ecad8bcd52c0adee27175788c7c8d2b86512d43.cfe-internal.js';

function validateSourceContract(source) {
  invariant(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
  invariant(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
  invariant(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function validateTargetContract(target) {
  invariant(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
  invariant(typeof target.hover === 'function', 'Expected hover to be a function.');
  invariant(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function validateType(type, allowArray) {
  if (allowArray && _Array$isArray(type)) {
    _forEachInstanceProperty(type).call(type, function (t) {
      return validateType(t, false);
    });
    return;
  }
  invariant(typeof type === 'string' || _typeof(type) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

export { validateSourceContract, validateTargetContract, validateType };
